fx.ns("shared.renderers", class ThemeTagRenderer extends fx.Component {
    
	constructor(data)
	{
        super(data);
    }

    create()
    {
        this.thumbnail = new fx.components.Image(this.data.thumbnail);
        this.text = new fx.components.Text(this.data.tag);
        var thumbsize = 55;
        if (fx.browser.isMobile)
            thumbsize = 70;
        
        this.addChild( this.thumbnail, { top : 0, right : 20, width : thumbsize, height : thumbsize});
        this.addChild( this.text, { top : "center", left : 20, width : "100%", height : 20});
    }

});
